import { GameContextState } from '@/features/game-context/store/game-context';
import { LaunchParams } from '@/features/game-context/types';

export const gameParams = [
  'gameUid',
  'userId',
  'rgi',
  'brand',
  'provider',
  'gameName',
  'region',
];

const launchParamsFilterList = ['geocomplyToken'];

// These keys are optional individually — downstream guards enforce
// the "at least one of providerRefDesktop / providerRefMobile" constraint.
const optionalParams = ['providerRefDesktop', 'providerRefMobile'];

export const extractGameContextParams = (
  launchParams: LaunchParams,
): [Omit<GameContextState, 'initialized'>, string[], string] => {
  const { geocomplyToken = '' } = launchParams ?? '';

  if (Object.entries(launchParams).length === 0) {
    return [launchParams, gameParams, geocomplyToken];
  }

  const filteredLaunchParams = Object.fromEntries(
    Object.entries(launchParams).filter(
      ([key]) => !launchParamsFilterList.includes(key),
    ),
  );

  const missingParamsList = Object.entries(filteredLaunchParams).reduce<
    string[]
  >(
    (acc, [key, value]) =>
      value === undefined && !optionalParams.includes(key)
        ? [...acc, key]
        : acc,
    [],
  );

  return [filteredLaunchParams, missingParamsList, geocomplyToken];
};
